import { ErrorFallbackCard } from '@ab-core/error-fallback-card';
import { FeatureNotifications, NewsModal } from '@ab-core/featurenotifications';
import ABFonts from '@ab-core/fonts';
import type { FallbackRendererType } from '@ab-core/functions/errorBoundary/';
import { ErrorBoundary } from '@ab-core/functions/errorBoundary/';
import { BottomBarContainer } from '@ab-core/bottom-bar/container';
import { ToastContainer } from '@ab-core/toast/container';
import type { WithChildren } from '@ab-core/utils/types';
import type { FC } from 'react';
import React, { useEffect } from 'react';
import { BaseCSS } from 'styled-bootstrap-grid';
import { Reset } from 'styled-reset';
import GlobalStyle from './globalstyles';
import { createErrorCode, detectMachineTranslation } from '../utils';

export type WrapperProps = WithChildren & {
    hasBottomBar: boolean;
};

const fallbackRenderer: FallbackRendererType = (error) => (
    <ErrorFallbackCard code={createErrorCode()} message={error.message} />
);

export const GlobalCss: FC<WrapperProps> = ({ children, hasBottomBar }) => {
    useEffect(() => {
        detectMachineTranslation();
    }, []);

    return (
        <>
            <Reset />
            <ABFonts />
            <GlobalStyle />
            <BaseCSS />
            <div id="ab-root">
                <ErrorBoundary fallbackRenderer={fallbackRenderer}>{children}</ErrorBoundary>
            </div>
            <FeatureNotifications />
            <NewsModal />
            <ToastContainer />
            {hasBottomBar && <BottomBarContainer />}
        </>
    );
};
